import emitter from "@/mono/lib/emitter";
import Workers from "@/mono/lib/webworkers/Workers";
import { events } from "mono/common/events";
import { useGlobalStore } from "mono/store/global";
import { create } from "zustand";
import awaitPageReady, { nextFrames } from "@/lib/pageReady";
import { wait } from "mono/lib/common";

function waitForEvent(eventName, { timeout = 5000 } = {}) {
  const startTime = performance.now();
  return new Promise((resolve) => {
    let resolved = false;
    const handler = () => {
      if (resolved) return;
      resolved = true;
      emitter.off(eventName, handler);
      console.log(
        `[PageTransition] ${eventName} received after ${(performance.now() - startTime).toFixed(0)}ms`
      );
      resolve();
    };

    emitter.on(eventName, handler);

    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        emitter.off(eventName, handler);
        console.warn(
          `[PageTransition] ${eventName} timed out after ${timeout}ms`
        );
        resolve();
      }
    }, timeout);
  });
}

// TODO: Just make 0 - 1 value
export const animatedPageProperties = create((set) => ({
  //   value: 0,
  //   properties: {},
}));

//onEnter	{ isAppearing, from, to, data }	Page was mounted and is about to enter
//onEntering	{ isAppearing, from, to, done, data }	Page is currently animating in - the done function has to be called to indicated animation is complete
//onEntered	{ isAppearing, from, to, data }	Page finished animating in after page navigation
//onExit	{ from, to }	Page is about to exit due to page navigation
//onExiting	{ from, to, done }	Page is currently animating out - the done function has to be called to indicated animation is complete

export default function applyPageTransition(
  pageName,
  { onEnter, onEntered, onExit } = {}
) {
  return {
    onEnter: ({ from, to }) => {
      emitter.emit(`${pageName}:ON_ENTER`);

      onEnter?.();
    },
    onEntering: async ({ from, to, done, data }) => {
      // console.log("ON_ENTERING", from, to);

      // Always reset scroll to top before showing the new page

      if (typeof window !== "undefined") window.scrollTo(0, 0);
      const lenis = useGlobalStore.getState().lenis;
      lenis?.scrollTo?.(0, { immediate: true });

      if (from) {
        const noWebGLImages = useGlobalStore.getState().noWebGLImages;
        const pageReadyPromise =
          pageName === "PROJECT"
            ? waitForEvent("PROJECT:PAGE_READY", { timeout: 10000 })
            : Promise.resolve();

        await wait(500);

        await Promise.all([
          Workers.animateGLBackgroundOut(),
          noWebGLImages && pageName === "PROJECT"
            ? Promise.resolve()
            : awaitPageReady({ root: document }),
        ]);

        await nextFrames(3);
        await pageReadyPromise;

        // Force scroll position update and resize to recalculate viewport visibility
        if (typeof window !== "undefined") {
          window.scrollTo(0, 0);
          lenis?.scrollTo?.(0, { immediate: true });
          window.dispatchEvent(new Event("resize"));
          await nextFrames(2);
        }
      } else {
        await awaitPageReady({ root: document });
      }

      emitter.emit(events.ROUTE_CHANGE_COMPLETE, { route: to });

      emitter.emit(`${pageName}:ON_ENTERING`, { from, to });
      // if (from) await wait(1000);

      return done();
    },
    onEntered: ({ from, to }) => {
      // console.log("ON_ENTERED", from, to);

      if (to !== "PROJECTS") useGlobalStore.getState().lenis.start();

      emitter.emit(`${pageName}:ON_ENTERED`, { from, to });
      //if(!from) emitter.emit(`${pageName}:INITIAL_ENTER`);
      onEntered?.();
    },
    onExit: async ({ from, to }) => {
      // console.log("ON_EXIT", from, to);

      // Back button

      //emitter.emit(events.ROUTE_CHANGE_START, { route: to });
      useGlobalStore.getState().lenis.stop();

      emitter.emit(`${pageName}:ON_EXIT`);
      onExit?.();
    },
    onExiting: async ({ from, to, done, data }) => {
      // console.log("ON_EXITING", from, to);

      emitter.emit(`${pageName}:ON_EXITING`);

      //await wait(1000);

      return done();
    },
  };
}
